/* Aveluno — Verhalten der eigenen Sections. Kein Framework, keine Abhängigkeit zu Horizon. */
(function () {
  'use strict';
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* ---------- Countdown in der Ankündigungsleiste ---------- */
  function countdown(bar) {
    const cells = $$('[data-av-unit]', bar);
    if (!cells.length) return;
    const hours = parseFloat(bar.dataset.avHours || '24');
    const key = 'av-countdown-' + (bar.dataset.avKey || 'default');
    let end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600 * 1000;
      try { sessionStorage.setItem(key, String(end)); } catch (e) {}
    }
    const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => {
      let left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) {
        left = 0;
        const done = bar.dataset.avDone;
        if (done) $('[data-av-label]', bar).textContent = done;
      }
      const v = {
        d: Math.floor(left / 86400),
        h: Math.floor(left / 3600) % 24,
        m: Math.floor(left / 60) % 60,
        s: left % 60,
      };
      cells.forEach((c) => (c.textContent = pad(v[c.dataset.avUnit])));
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Galerie ---------- */
  function gallery(root) {
    const slides = $$('.av-gallery__slide', root);
    const thumbs = $$('.av-gallery__thumb', root);
    if (!slides.length) return;
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        s.classList.toggle('is-active', k === i);
        const v = s.querySelector('video');
        if (v) k === i ? v.play().catch(() => {}) : v.pause();
      });
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    const prev = $('[data-av-prev]', root);
    const next = $('[data-av-next]', root);
    if (prev) prev.addEventListener('click', () => show(i - 1));
    if (next) next.addEventListener('click', () => show(i + 1));
    show(0);
  }

  /* ---------- Aufklapp-Elemente (PDP-Akkordeon und FAQ) ---------- */
  function accordions(root) {
    $$('[data-av-acc] button', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('[data-av-acc]');
        const group = item.parentElement;
        const open = item.classList.contains('is-open');
        if (group && group.dataset.avSingle === 'true') {
          $$('[data-av-acc]', group).forEach((o) => o.classList.remove('is-open'));
        }
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* ---------- Angebotsauswahl + Warenkorb ---------- */
  function offer(form) {
    const rows = $$('.av-offer__row, .av-tier', form);
    const sync = () => {
      rows.forEach((r) => {
        const input = $('input', r);
        r.classList.toggle('is-on', !!input && input.checked);
      });
    };
    const total = $('[data-av-total]', form);
    // Format an den Shop angleichen (€79,95), Vorlage ist der Startwert im Markup
    const vorlage = total ? total.textContent.trim() : '';
    const geld = (cent) => {
      const zahl = (cent / 100).toFixed(2).replace('.', ',');
      return vorlage.replace(/[\d.,]+/, zahl);
    };
    const updateTotal = () => {
      const gewaehlt = $('input[name="av-variant"]:checked', form);
      if (total && gewaehlt && gewaehlt.dataset.avPrice) {
        total.textContent = geld(Number(gewaehlt.dataset.avPrice));
      }
    };
    rows.forEach((r) => {
      const input = $('input', r);
      if (!input) return;
      r.addEventListener('click', (e) => {
        if (e.target.tagName !== 'INPUT') {
          if (input.type === 'checkbox') input.checked = !input.checked;
          else input.checked = true;
        }
        sync(); updateTotal();
      });
      input.addEventListener('change', () => { sync(); updateTotal(); });
    });
    sync(); updateTotal();

    const btn = $('[data-av-add]', form);
    if (!btn) return;
    const label = btn.textContent;
    btn.addEventListener('click', async () => {
      const main = $('input[name="av-variant"]:checked', form);
      if (!main) return;
      const items = [{ id: Number(main.value), quantity: 1 }];
      $$('input[data-av-upsell]:checked', form).forEach((u) =>
        items.push({ id: Number(u.value), quantity: 1 })
      );
      btn.disabled = true;
      btn.textContent = btn.dataset.avBusy || 'Wird hinzugefügt …';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        });
        if (!res.ok) throw new Error((await res.json()).description || 'Fehler');
        const to = form.dataset.avAfter || 'cart';
        if (to === 'checkout') window.location.href = '/checkout';
        else if (to === 'cart') window.location.href = '/cart';
        else {
          btn.textContent = btn.dataset.avDone || 'Hinzugefügt ✓';
          setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1800);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return;
        }
      } catch (err) {
        btn.textContent = err.message || 'Nicht möglich';
        setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 2500);
      }
    });
  }

  /* ---------- Video stummschalten ---------- */
  function videos(root) {
    $$('[data-av-mute]', root).forEach((btn) => {
      const vid = $('video', btn.closest('.av-video__stage'));
      if (!vid) return;
      const paint = () => {
        btn.querySelector('[data-av-on]').style.display = vid.muted ? 'none' : '';
        btn.querySelector('[data-av-off]').style.display = vid.muted ? '' : 'none';
      };
      btn.addEventListener('click', () => { vid.muted = !vid.muted; paint(); });
      paint();
    });
  }

  /* ---------- Weitere Bewertungen ---------- */
  function reviews(root) {
    const btn = $('[data-av-more]', root);
    if (!btn) return;
    btn.addEventListener('click', () => {
      const hidden = $$('.av-rev__item.is-hidden', root).slice(0, 4);
      hidden.forEach((h) => h.classList.remove('is-hidden'));
      if (!$('.av-rev__item.is-hidden', root)) btn.remove();
    });
  }

  /* ---------- Produktkarte mit Varianten + Menge ---------- */
  function featured(form) {
    const opts = $$('.av-fp__opt', form);
    const priceNow = $('[data-av-now]', form);
    const priceWas = $('[data-av-was]', form);
    const hidden = $('input[name="id"]', form);
    opts.forEach((o) => {
      o.addEventListener('click', () => {
        opts.forEach((x) => x.classList.toggle('is-on', x === o));
        hidden.value = o.dataset.avId;
        if (priceNow) priceNow.textContent = o.dataset.avPrice;
        if (priceWas) priceWas.textContent = o.dataset.avCompare || '';
      });
    });
    const qty = $('input[name="quantity"]', form);
    $$('[data-av-step]', form).forEach((b) =>
      b.addEventListener('click', () => {
        qty.value = Math.max(1, Number(qty.value || 1) + Number(b.dataset.avStep));
      })
    );
  }

  /* ---------- Bewertungs-Karussell im Produktbereich ---------- */
  function strip(root) {
    const items = $$('.av-strip__item', root);
    if (items.length < 2) return;
    let i = 0;
    const show = (n) => {
      i = (n + items.length) % items.length;
      items.forEach((el, k) => el.classList.toggle('is-active', k === i));
    };
    const prev = $('[data-av-strip-prev]', root);
    const next = $('[data-av-strip-next]', root);
    if (prev) prev.addEventListener('click', () => show(i - 1));
    if (next) next.addEventListener('click', () => show(i + 1));
  }

  /* ---------- Uhr bis zum Annahmeschluss ---------- */
  function lieferuhr(root) {
    const out = $('[data-av-deliv-clock]', root);
    if (!out) return;
    const stunde = parseInt(root.dataset.avCutoff || '16', 10);
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const jetzt = new Date();
      const ziel = new Date(jetzt);
      ziel.setHours(stunde, 0, 0, 0);
      if (ziel <= jetzt) ziel.setDate(ziel.getDate() + 1);
      let s = Math.floor((ziel - jetzt) / 1000);
      out.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Mengenstaffel im Warenkorb ---------- */
  function upsell(root) {
    $$('[data-av-up-add]', root).forEach((btn) => {
      btn.addEventListener('click', async () => {
        const id = Number(btn.dataset.avUpAdd);
        const label = btn.dataset.avUpLabel || btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Wird hinzugefügt …';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
          });
          if (!res.ok) throw new Error((await res.json()).description || 'Fehler');
          window.location.reload();
        } catch (err) {
          btn.textContent = err.message || 'Nicht möglich';
          setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 2500);
        }
      });
    });
  }

  function init(scope) {
    $$('[data-av-bar]', scope).forEach(countdown);
    $$('[data-av-gallery]', scope).forEach(gallery);
    $$('[data-av-offer]', scope).forEach(offer);
    $$('[data-av-featured]', scope).forEach(featured);
    $$('[data-av-reviews]', scope).forEach(reviews);
    $$('[data-av-strip]', scope).forEach(strip);
    $$('[data-av-deliv]', scope).forEach(lieferuhr);
    $$('[data-av-up]', scope).forEach(upsell);
    accordions(scope);
    videos(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  // Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
